import React, { useEffect, useState } from 'react'
import { Bar } from 'react-chartjs-2'
import WTypography from '../../../../Components/whiteTypography'
import { deviseCal } from 'utils/helpers'
import { useSelector } from 'react-redux'
import { Chart, registerables } from 'chart.js'

Chart.register(...registerables)

const optionsbar = {
  indexAxis: 'x',
  aspectRatio: 1.05,
  onClick: function (evt, element) {
    // console.log(evt, element);
  },
  // Elements options apply to all of the options unless overridden in a dataset
  // In this case, we are setting the border of each horizontal bar to be 2px wide
  elements: {
    bar: {
      borderWidth: 2,
    },
  },
  responsive: true,
  scales: {
    x: {
      ticks: {
        color: 'white', // Couleur du texte pour les axes X
      },
      grid: {
        color: 'rgba(255,255,255,0.1)', // Optionnel: couleur des lignes de grille pour l'axe X
      },
    },
    y: {
      ticks: {
        color: 'white', // Couleur du texte pour les axes Y
      },
      grid: {
        color: 'rgba(255,255,255,0.1)', // Optionnel: couleur des lignes de grille pour l'axe Y
      },
    },
  },
  plugins: {
    targetLines: {
      color: 'red',
      width: 2,
      label: {
        display: true,
        position: 'center',
      },
    },
    // legend: {
    //   display: "none",
    // },
    //   title: {
    //     display: false,
    //     text: 'Mon cashflow',
    //   },
    legend: {
      display: false,
    },
    datalabels: {
      display: false,
      color: 'white',
      formatter: (val, ctx) => ctx.chart.data.labels[ctx.dataIndex],
    },
    tooltips: {
      callbacks: {
        label: function (tooltipItem) {
          return tooltipItem.yLabel
        },
      },
    },
  },
}

function CFBarChart({ reports, revenusDespense }) {
  const siteDevise = useSelector((store) => store.devise)

  const [data, setRevData] = useState({
    labels: [],
    target: [],
    datasets: [
      {
        data: [],
        // backgroundColor: ["#93b7ff", "#6087cd", "#295a9c"],
        borderColor: ['#93b7ff', '#6087cd', '#295a9c'],
        backgroundColor: ['white'],
        borderWidth: 1,
      },
    ],
  })

  const targetLinePlugin = {
    id: 'targetLines',
    afterDraw: (chart) => {
      const {
        ctx,
        chartArea,
        scales: { x, y },
      } = chart
      const targetLines = chart.config.options.plugins.targetLines

      chart.data.datasets[0].data.forEach((value, index) => {
        const targetValue = data.target[index]
        const xPos = x.getPixelForValue(index)
        const yPos = y.getPixelForValue(targetValue)
        const barWidth =
          x.getPixelForValue(1) -
          x.getPixelForValue(0) -
          (x.getPixelForValue(1) - x.getPixelForValue(0)) / chart.data.labels.length

        ctx.font = '19px Arial'
        ctx.save()
        ctx.strokeStyle = targetLines.color
        ctx.lineWidth = targetLines.width
        ctx.setLineDash([]) // Solid line
        ctx.beginPath()

        ctx.moveTo(xPos - barWidth + 2 / 2, yPos)
        ctx.lineTo(xPos + barWidth + 2 / 2, yPos)

        ctx.stroke()
        // ctx.restore()

        if (targetLines.label.display) {
          // ctx.save()
          ctx.fillStyle = targetLines.color
          ctx.textAlign = 'center' // Center-align the text
          ctx.fillText(`${targetValue}`, xPos, yPos - 15) // Center the text over the line
        }
        ctx.restore()
      })
    },
  }

  useEffect(() => {
    let labels = []
    let data = []
    let target = []
    revenusDespense &&
      reports &&
      reports.calculation.group_of_categories.map((cat, i) => {
        labels.push(cat.name)
        data.push(cat.aggregate)
        return ''
      })
    if (revenusDespense !== true) {
      // console.log(reports)
      target = reports.calculation?.target
      reports && labels.push(reports.calculation.label1, reports.calculation.label2)
      reports && data.push(reports.calculation.totalRev, reports.calculation.totalDep)
    }
    data.forEach((e, i) => {
      data[i] = deviseCal(e, siteDevise.devise.to_eur)
    })

    target = target.map((e) => {
      return deviseCal(e, siteDevise.devise.to_eur)
    })
    target.forEach((e) => data.push(parseInt(e) * 1.2))
    // data.push('100000')
    // console.log(data)
    reports &&
      setRevData({
        labels: labels,
        target: target,
        datasets: [
          {
            // label: "Répartition revenus",
            data: data,
            backgroundColor: ['#93b7ff', '#6087cd', '#295a9c'],
            borderColor: ['#93b7ff', '#6087cd', '#295a9c'],
            // backgroundColor: 'rgba(75, 192, 192, 0.2)',
            // borderColor: 'rgba(75, 192, 192, 1)',
            borderWidth: 1,
            hoverOffset: 4,
          },
        ],
      })
  }, [reports, siteDevise.devise])
  const HorizontalBarChart = () => (
    <>
      {reports && data.labels.length === 0 && data.datasets[0].data.length === 0 ? (
        <WTypography variant="h6" align="center" marginTop="10rem">
          Aucune donnée
        </WTypography>
      ) : reports && reports.calculation.header_value !== 0 ? (
        <>
          {reports.calcul === 'cashflow.js' && data.target ? (
            <Bar data={data} height={'270%'} options={optionsbar} plugins={[targetLinePlugin]} />
          ) : (
            <Bar data={data} height={'270%'} options={optionsbar} />
          )}
        </>
      ) : (
        <WTypography variant="h6" align="center" marginTop="10rem">
          Aucune donnée
        </WTypography>
      )}
    </>
  )
  return (
    <>
      <HorizontalBarChart />
    </>
  )
}

export default CFBarChart
